import styled from 'styled-components'
import { Text } from '../Text'
import { PropsWithChildren, HTMLAttributes } from 'react'

type CardProps = PropsWithChildren<HTMLAttributes<HTMLDivElement>>

const Card = styled.div<{ $padding?: string; $border?: string; $borderRadius?: string }>`
  width: 100%;
  border-radius: 16px;
  padding: 1.25rem;
  padding: ${({ $padding }) => $padding};
  border: ${({ $border }) => $border};
  border-radius: ${({ $borderRadius }) => $borderRadius};
`
export default Card

export const LightCard = styled(Card)`
  border: 1px solid ${({ theme }) => theme.bg2};
  background-color: ${({ theme }) => theme.bg1};
`

export const GreyCard = styled(Card)`
  background-color: ${({ theme }) => theme.bg2};
`

export const OutlineCard = styled(Card)`
  border: 1px solid ${({ theme }) => theme.bg3};
`

export const YellowCard = styled(Card)`
  border: 1px solid ${({ theme }) => theme.bg3};
  color: ${({ theme }) => theme.yellow1};
  font-weight: 500;
`

export const OrangeCard = styled(Card)`
  border: 1px solid ${({ theme }) => theme.bg3};
  color: ${({ theme }) => theme.orange1};
  font-weight: 500;
`

export const PinkCard = styled(Card)`
  border: 1px solid ${({ theme }) => theme.bg3};
  color: ${({ theme }) => theme.primary1};
  font-weight: 500;
`

export const GreenCard = styled(Card)`
  background-color: ${({ theme }) => theme.primary1};
  color: ${({ theme }) => theme.primaryText2};
  font-weight: 500;
`

const BlueCardStyled = styled(Card)`
  background-color: ${({ theme }) => theme.bg2};
  color: ${({ theme }) => theme.text1};
  border-radius: 12px;
  width: fit-content;
`

export const BlueCard = ({ children, ...rest }: CardProps) => {
  return (
    <BlueCardStyled {...rest}>
      <Text fontWeight={500} color="#2172E5">
        {children}
      </Text>
    </BlueCardStyled>
  )
}
